import React from 'react'
import { Chip } from './styles'

export const chipFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { transparent, theme, val, color } = formatExtraData

  return (
    <div>
      <Chip
        background={color}
        color={transparent ? color : theme.white}
        shown={val(row)}
      >
        {val(row)}
      </Chip>
    </div>
  )
}
